module.exports = __webpack_public_path__ + "img/ideas.38e3e40e.svg";